import ReactHtmlParser from 'react-html-parser';
import { distributedCalendar } from './DistributedCalendar';
import { default_timezone } from "./Event" // THIS IS A MISTAKE -> Should always save as UTC
import { getSession } from '../../auth';
import dayjs from 'dayjs'

type KwikEventDTO = {

}

type GoogleCalendarDTO = {

}

type MicrosoftCalendarDTO = {

}

export const stateTranslation = {
    'accepted'  : {present: 'Aceitar'   ,  past: 'Aceito', vMicrosoft: 'accept'},
    'pending'   : {present: 'Aguardando',  past: 'Aguardou', vMicrosoft: 'none', vGoogle: 'needsAction'},
    'declined'  : {present: 'Recusar'   ,  past: 'Recusou', vMicrosoft: 'decline'},
    'creating'  : {present: 'Criar'     ,  past: 'Criou', vMicrosoft: 'create', vGoogle: "needsAction"},
    'tentative' : {present: 'Talvez'    ,  past: 'Talvez', vMicrosoft: 'tentativelyAccept'}
}

type AttendeesDTO = {
    email: str,
    status: 'accepted' | 'pending' | 'declined' | 'creating' | 'tentative'
}

type Providers = 'KWIK' | 'MICROSOFT_CALENDAR' | 'GOOGLE_CALENDAR'

type UnifiedEventDTO = {
    id: int,
    title: str,
    subject: str,
    description: str,
    email: str,
    status: str,
    calendar: Providers,
    localization: str,
    conference_room: str,
    startDate: str,
    endDate: str,
    organizer: str,
    attendees: Array<AttendeesDTO>,
    //
    owner: str,
    type: str,
    contact_group: Array,
    event: str,
    target: str,
    contact: any,
    send_notification: str,
    send_whatsapp_notification: str,
    is_recurrent: Boolean,
    activity: any,

    contact_data: any,
    contact_enterprise: any,
    contact_enterprise_data: any,
    contact_group: any,
    contact_group_data: any,
    notification_time: date,
    transformed: Boolean
}

const attendeeStatus = (status) => {
    switch(status){
        case 'accepted':
            return 'accepted'
        case 'declined':
            return 'declined'
        case 'tentativelyAccepted':
        case 'tentative':
            return 'tentative'
        default:
            return 'pending'
    }
}

const normalizeDate = (dateTime, timeZone) => {
        const hasOffset = /([+-]\d{2}:\d{2}|Z)$/i.test(dateTime);

        if (hasOffset) {
            // Já tem offset → NÃO usar .tz()
            return dayjs(dateTime).toDate();
        }

        // Não tem offset → usar timezone informado
        return dayjs.tz(dateTime, timeZone).toDate();
        };

const eventObject = ({object, provider = "KWIK", source} : {object: KwikEventDTO | GoogleCalendarDTO | MicrosoftCalendarDTO, provider: Providers, source: str}) => {

    if (object.transformed) 
        return object

    const loc = object.location;
    const distributedCalendaDict = distributedCalendar.data_dict
    const hasResponse = object.responseStatus
    const organizer = object.organizer?.email || object.organizer?.emailAddress?.address

    const attendees: Array<attendeesDTO> = (object.attendees || []).map(attendee => { 
        const response: attendeesDTO = {
            email: attendee.email || attendee.emailAddress?.address,
            status: attendeeStatus(attendee?.responseStatus || attendee.status?.response),
        }

        //Microsoft only
        if (hasResponse && response.email === organizer)
            response.status = 'accepted'
        else if (hasResponse && source === response.email)
            response.status = attendeeStatus(hasResponse.response)

        return response
    })

    const start = normalizeDate(object.start?.dateTime || object.target_date, object.start?.timeZone || default_timezone)

    if (!object.id)
        object.target_enddate = dayjs(start).add(1, 'hour').toDate()

    const end   = normalizeDate(object.end?.dateTime || object.target_enddate || object.target_date, object.end?.timeZone || default_timezone)

    const response: UnifiedEventDTO = {
        id: object.id || 0,
        calendar: provider,
        title: object.summary || object.subject || object.description,
        description: object.long_description || object.body?.content || object.description,
        parsed_description: ReactHtmlParser(object.long_description || object.body?.content || object.description),
        localization: (typeof loc === "object" ? loc?.displayName : loc) ?? "",
        startDate: start,
        endDate: end,
        email: source,
        conference_room: object.hangoutLink || object.onlineMeeting?.joinUrl || true,
        attendees: attendees,
        organizer: organizer,
        color: distributedCalendaDict[`${source}_${provider}`]?.color,
        event: object.event,
        owner: object.owner || getSession().id,
        target: distributedCalendar.data_dict[`${source}_${provider}`]?.owner || getSession().id,
        type: object.type,
        send_notification: object.send_notification ?? true,
        send_whatsapp_notification: object.send_whatsapp_notification ?? true,
        whatsapp_notification: object.whatsapp_notification || null,
        activity: object.activity,
        is_recurrent: object.recurringEventId || object.seriesMasterId || object.is_recurrent || "UNIQUE",
        contact: object.contact_data || object.contact,
        contact_data: object.contact_data,
        contact_enterprise: object.contact_enterprise_data || object.contact_enterprise,
        contact_enterprise_data: object.contact_enterprise_data,
        contact_group: object.contact_group_data || object.contact_group,
        contact_group_data: object.contact_group_data,
        status: object.status,
        notification_time: object.notification_time || '10',
        transformed: true
    }

    return response
}

export default eventObject
